import React, { useEffect, useState } from "react";
import "./SidebarDashboard.scss";
import { Link, useLocation } from "react-router-dom";
import { Path } from "../../Routing/Constant/RoutePaths.jsx";
import useCurrentWidth from "../Commons/customHooks/useCurrentWidth.jsx";
import logo from "../../Assets/logo.svg";
import smallLogo from "../../Assets/smallLogo.png";
import {
  CurrencyIcon,
  DashboardIcon,
  MerchantIcon,
  PaymentIcon,
  PayoutsIcon,
  SettingsIcon,
  TransactionsIcon,
} from "../../Assets/Assets.jsx";

function SidebarDashboard() {
  const [collapsed, setCollapsed] = useState(true);
  const width = useCurrentWidth();
  const location = useLocation();
  const currentPath = location.pathname;
  const menuItems = [
    {
      to: Path.DASHBOARD,
      icon: <DashboardIcon />,
      label: "Dashboard",
    },
    {
      to: Path.MERCHANT,
      icon: <MerchantIcon />,
      label: "Merchant Details",
    },
    {
      to: Path.PAYOUTS,
      icon: <PayoutsIcon />,
      label: "Payouts",
    },
    {
      to: Path.TRANSACTIONS,
      icon: <TransactionsIcon />,
      label: "Transaction Details",
    },
    {
      to: Path.PREFERENCES,
      icon: <CurrencyIcon />,
      label: "Currency Preferences",
    },
    {
      to: Path.PAYMENY,
      icon: <PaymentIcon />,
      label: "Fee",
    },

    {
      to: Path.SETTINGS,
      icon: <SettingsIcon />,
      label: "Settings",
    },
  ];

  const isActive = (path) => {
    // Check if the currentPath matches or starts with /merchant for all sub-paths
    if (path === Path.MERCHANT) {
      return currentPath.startsWith("/merchant");
    } else if (path === Path.PAYOUTS) {
      return currentPath.startsWith("/payouts");
    }
    return currentPath === path;
  };

  useEffect(() => {
    if (width > 991) {
      setCollapsed(false);
    } else {
      setCollapsed(true);
    }
  }, [width]);

  return (
    <div className={`sidebar ${width <= 991 ? "sidebarResponsive" : ""}`}>
      <div className="sidebar_logo">
        <Link to={Path.DASHBOARD}>
          <img className="logo" src={logo} alt="" />
          <img className="smallLogo" src={smallLogo} alt="" />
        </Link>
      </div>
      <div className="sidebar_bottom">
        <div className="sidebar_link">
          <div className="sidebar_link_items">
            {menuItems?.map((ele, index) => (
              <Link
                key={index}
                to={ele.to}
                className={isActive(ele.to) ? "active" : ""}
              >
                <div className="sidebar_link_items_icon"> {ele.icon}</div>
                {!collapsed && ele.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SidebarDashboard;
